import { render, staticRenderFns } from "./likeUsers.vue?vue&type=template&id=2d9f9093&scoped=true&"
import script from "./likeUsers.vue?vue&type=script&lang=js&"
export * from "./likeUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9f9093",
  null
  
)

export default component.exports